import React from 'react';
import { Search } from 'lucide-react';
import { Input } from './ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

export const FestivalFilters = ({
  search,
  onSearchChange,
  region,
  onRegionChange,
  month,
  onMonthChange,
  sort,
  onSortChange,
  regions,
  months,
}) => {
  return (
    <section className="py-8 md:py-10">
      <div className="container-custom">
        <div className="rounded-2xl bg-white p-5 shadow-sm md:p-6">
          <div className="grid gap-4 lg:grid-cols-[1.2fr,0.9fr,0.9fr,0.9fr]">
            <div className="relative">
              <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input
                value={search}
                onChange={(event) => onSearchChange(event.target.value)}
                placeholder="Søg efter festival eller by"
                className="h-12 rounded-xl border-border/70 bg-section-bg pl-11"
              />
            </div>

            <Select value={region} onValueChange={onRegionChange}>
              <SelectTrigger className="h-12 rounded-xl border-border/70 bg-section-bg">
                <SelectValue placeholder="Vælg landsdel" />
              </SelectTrigger>
              <SelectContent>
                {regions.map((option) => (
                  <SelectItem key={option} value={option}>
                    {option}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <Select value={month} onValueChange={onMonthChange}>
              <SelectTrigger className="h-12 rounded-xl border-border/70 bg-section-bg">
                <SelectValue placeholder="Vælg måned" />
              </SelectTrigger>
              <SelectContent>
                {months.map((option) => (
                  <SelectItem key={option} value={option}>
                    {option}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <Select value={sort} onValueChange={onSortChange}>
              <SelectTrigger className="h-12 rounded-xl border-border/70 bg-section-bg">
                <SelectValue placeholder="Sortér" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="earliest">Tidligste dato</SelectItem>
                <SelectItem value="latest">Seneste dato</SelectItem>
                <SelectItem value="alphabetical">Alfabetisk A-Å</SelectItem>
                <SelectItem value="largest">Største festivaler</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
    </section>
  );
};
